import React from "react";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import Suggestion from "./Suggestion";
import NovelSkeleton from "./NovelSkeleton";

function Suggestions({ suggestionNovels, currentNovel }) {
  const skeleton = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}];

  return (
    <div className="sm:mt-[100px] mt-[50px] ">
      <div className="h-full px-[15px] overflow-hidden md:px-0">
        <div className="relative w-auto flex text-center justify-center sm:justify-start md:justify-start items-center">
          <h1 className="font-size relative text-tertiary ">
            YOU MIGHT ALSO LIKE
          </h1>
        </div>
        <div className="mt-[55px] relative ">
          <Swiper
            // install Swiper modules
            modules={[Navigation, Pagination, Scrollbar, A11y]}
            spaceBetween={16}
            slidesPerView={2}
            navigation
            pagination={{
              type: "progressbar",
            }}
            breakpoints={{
              640: {
                slidesPerView: 2,
                spaceBetween: 32,
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 40,
              },
              1024: {
                slidesPerView: 4,
                spaceBetween: 40,
              },
              1280: {
                slidesPerView: 5,
                spaceBetween: 40,
              },
              1536: {
                slidesPerView: 5,
                spaceBetween: 40,
              },
            }}
          >
            {suggestionNovels.pending === true || currentNovel?.pending === true
              ? skeleton?.map((novel) => (
                  <SwiperSlide key={Math.random()}>
                    <NovelSkeleton novel={novel} />
                  </SwiperSlide>
                ))
              : suggestionNovels?.novels?.map((novel) => (
                  <SwiperSlide key={Math.random()}>
                    <Suggestion novel={novel} />
                  </SwiperSlide>
                ))}
          </Swiper>
          <div className="absolute right-0 mt-10 sm:mt-0 sm:-bottom-[75px] -bottom-[50px] z-50 text-tertiary font-SoraL uppercase text-[12px]">
            Scroll
          </div>
        </div>

        <div className="my-carousel-progress mt-[75px] relative">
          <div className="my-carousel-progress-bar"></div>
          <div className="absolute right-0 text-tertiary font-SoraL mt-2 uppercase text-[12px]">
            Scroll
          </div>
        </div>
      </div>
    </div>
  );
}

export default Suggestions;
